import moment from "moment";
import {
  EMediaTranscodingItemStatus,
  TranscodingItem,
} from "./transcoding-item";
import { ICommonUtilInterface } from "../common/common-util.interface";
import { ContentControlTranscodingItem } from "./content-control-transcoding-item";

export class TranscoderJobDetails {
  constructor(
    public id: string,
    public name: string,
    public destinationId: number,
    public priority: ETranscodingJobPriority,
    public status: ETranscodingJobStatus,
    public estimatedStartTime: moment.Moment,
    public estimatedEndTime: moment.Moment,
    public actualStartTime: moment.Moment,
    public actualEndTime: moment.Moment,
    public transcodingItems: TranscodingItem[],
    public transcodingProfileId?: number,
    public sideEffectId?: number,
    public executeOnlySideEffects?: boolean,
  ) {}

  itemStatuses: EMediaTranscodingItemStatus[] = [];

  clone(utils: ICommonUtilInterface): TranscoderJobDetails {
    const newId = utils.generateGuid();
    const clonedTranscodingItems = this.transcodingItems.map((item) =>
      item.clone(utils),
    );
    return new TranscoderJobDetails(
      newId,
      `Replicated from ${this.name}`,
      this.destinationId,
      ETranscodingJobPriority.Low,
      ETranscodingJobStatus.Active,
      null,
      null,
      null,
      null,
      clonedTranscodingItems,
      this.transcodingProfileId,
      this.sideEffectId,
      this.executeOnlySideEffects,
    );
  }

  public static createNewContentControlItemJob(
    utils: ICommonUtilInterface,
    name: string,
    destionationId: number,
    transcodingProfileId: number,
    contentControlItemUid: string,
    mediaDurationMs: number,
  ): TranscoderJobDetails {
    const id = utils.generateGuid();

    return new TranscoderJobDetails(
      id,
      name,
      destionationId,
      ETranscodingJobPriority.Low,
      ETranscodingJobStatus.Active,
      null,
      null,
      null,
      null,
      [
        new ContentControlTranscodingItem(
          utils.generateGuid(),
          contentControlItemUid,
          "",
          "",
          0,
          0,
          mediaDurationMs,
          EMediaTranscodingItemStatus.Pending,
          "",
          null,
          "",
        ),
      ],
      transcodingProfileId,
      -1,
    );
  }
}
export enum ETranscodingDestination {
  TranscodingBucket,
}
export enum ETranscodingJobPriority {
  Low,
  Medium,
  High,
}

export enum ETranscodingJobStatus {
  Active = 0,
  History,
}
